import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

const StackRolesDescriptionCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<StackRoleBindingView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={roleBinding.role.description} />
    </TableSimpleCell>
  );
};

export default StackRolesDescriptionCell;
